'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserKind$() {
  this.cd0 = null;
  this.cd1 = false;
}
export { $c_Lpresto_types$UserKind$ as $c_Lpresto_types$UserKind$ };
$p = $c_Lpresto_types$UserKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserKind$;
/** @constructor */
function $h_Lpresto_types$UserKind$() {
}
export { $h_Lpresto_types$UserKind$ as $h_Lpresto_types$UserKind$ };
$h_Lpresto_types$UserKind$.prototype = $p;
$p.sB = (function() {
  if ((!this.cd1)) {
    this.cd0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.cd1 = true;
  }
  return this.cd0;
});
var $d_Lpresto_types$UserKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserKind$, "presto.types$UserKind$", ({
  a33: 1,
  D: 1
}));
export { $d_Lpresto_types$UserKind$ as $d_Lpresto_types$UserKind$ };
var $n_Lpresto_types$UserKind$;
function $m_Lpresto_types$UserKind$() {
  if ((!$n_Lpresto_types$UserKind$)) {
    $n_Lpresto_types$UserKind$ = new $c_Lpresto_types$UserKind$();
  }
  return $n_Lpresto_types$UserKind$;
}
export { $m_Lpresto_types$UserKind$ as $m_Lpresto_types$UserKind$ };
//# sourceMappingURL=presto.types$-User-Kind$.js.map
